import { Base } from "../core/base.model";
import { Evidencia } from "./evidencia.model";
import { TicketsEstatus } from "src/app/utilerias/enums/tickets-estatus.enum";

export class Comentario extends Base {
    id: number;
    descripcion: String;
    fecha: Date;
    id_usuario: number;
    id_estatus: TicketsEstatus;
    id_ticket: number;
    nombreUsuario: String;
    nombreEstatus: String;

    nombreEvidencia: String;
    rutaEvidencia: String;
    listaEvidencia: Array<Evidencia>;
}
